if (!customElements.get('wls-s-product-form-frequency')) {
  class WLS_S_ProductFormFrequency extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        inputSellingPlan: 'input[name="selling_plan"]',
        inputPurchaseType: 'input[name="purchase-type"]',
        inputQuantity: 'input[name="quantity"]',
        inputQuantityPreselected: 'input[name="quantity_preselected"]',
        inputSellingPlanValue: 'input[name="selling_plan_value"]',
        subscriptionGroup: 'js-wls-s-product-form-frequency-subscription',
        oneTimeGroup: 'js-wls-s-product-form-frequency-one-time',
        subscriptionDiscount: 'js-subscription-discount',
      };

      this.selectors = this.getSelectors;
      this.dataAttributes = this.getDataAttributes;

      this.purchaseType = {
        OTP: 'one-time',
        SUB: 'subscription',
      };

      this.currentSellingPlan = '';
    }

    get getSelectors() {
      return {
        sellingPlanInput: this.querySelector(this.classes.inputSellingPlan),
        purchaseTypeInputs: this.querySelectorAll(this.classes.inputPurchaseType),
        quantityPreselectedInputs: this.querySelectorAll(this.classes.inputQuantityPreselected),
        subscriptionGroup: this.querySelector(`.${this.classes.subscriptionGroup}`),
        oneTimeGroup: this.querySelector(`.${this.classes.oneTimeGroup}`),
        sellingPlanValueInputs: this.querySelectorAll(this.classes.inputSellingPlanValue),
      };
    }

    get getDataAttributes() {
      return {
        blockId: this.getAttribute('data-block-id'),
        sectionId: this.getAttribute('data-section-id'),
      };
    }

    connectedCallback() {
      this.bindEvents();
    }

    disconnectedCallback() {
      this.unbindEvents();
    }

    bindEvents() {
      this.selectors.purchaseTypeInputs.forEach((input) => {
        input.addEventListener('change', this.handlePurchaseTypeChange.bind(this));
      });

      this.selectors.quantityPreselectedInputs.forEach((input) => {
        input.addEventListener('change', this.handleQuantityPreselectedChange.bind(this));
      });

      this.selectors.sellingPlanValueInputs.forEach((input) => {
        input.addEventListener('change', this.handleSellingPlanOptionChange.bind(this));
      });
    }

    unbindEvents() {
      this.selectors.purchaseTypeInputs.forEach((input) => {
        input.removeEventListener('change', this.handlePurchaseTypeChange.bind(this));
      });

      this.selectors.quantityPreselectedInputs.forEach((input) => {
        input.removeEventListener('change', this.handleQuantityPreselectedChange.bind(this));
      });

      this.selectors.sellingPlanValueInputs.forEach((input) => {
        input.removeEventListener('change', this.handleSellingPlanOptionChange.bind(this));
      });
    }

    handlePurchaseTypeChange(event) {
      const target = event.target;
      const value = target.value;

      this.selectors.purchaseTypeInputs.forEach((input) => {
        input.checked = false;
      });
      target.checked = true;

      this.setSellingPlanInput(value);
    }

    setSellingPlanInput(value) {
      if (value === this.purchaseType.SUB) {
        const firstSellingPlan = this.selectors.subscriptionGroup.querySelectorAll(
          this.classes.inputSellingPlanValue
        )[0];
        this.selectors.sellingPlanInput.value = firstSellingPlan.value;
        this.currentSellingPlan = firstSellingPlan.value;

        this.selectors.subscriptionGroup.classList.add('active');
        this.selectors.oneTimeGroup.classList.remove('active');

        this.selectors.sellingPlanValueInputs.forEach((input) => {
          input.checked = false;
        });
        firstSellingPlan.checked = true;
        this.updateSubscriptionDiscount();
      }

      if (value === this.purchaseType.OTP) {
        this.selectors.sellingPlanInput.value = '';
        this.currentSellingPlan = '';

        this.selectors.subscriptionGroup.classList.remove('active');
        this.selectors.oneTimeGroup.classList.add('active');
      }
    }

    handleSellingPlanOptionChange(event) {
      const target = event.target;
      const value = target.value;

      this.selectors.sellingPlanValueInputs.forEach((input) => {
        input.checked = false;
      });
      target.checked = true;

      this.selectors.sellingPlanInput.value = value;
      this.currentSellingPlan = value;

      this.updateSubscriptionDiscount();
    }

    handleQuantityPreselectedChange(event) {
      const target = event.target;
      const quantity = target.value;

      this.selectors.quantityPreselectedInputs.forEach((input) => {
        input.checked = false;
      });
      target.checked = true;

      const quantityInput = target.closest('form').querySelector(this.classes.inputQuantity);

      if (quantityInput) {
        quantityInput.value = quantity;

        const changeEvent = new Event('change', { bubbles: true });
        quantityInput.dispatchEvent(changeEvent);
      }
    }

    updateSubscriptionDiscount() {
      const discountElement = this.querySelector(`.${this.classes.subscriptionDiscount}`);
      if (!discountElement || !this.currentSellingPlan) return;

      const sellingPlanInput = this.querySelector(
        `input[name="selling_plan_value"][value="${this.currentSellingPlan}"]`
      );
      if (!sellingPlanInput) return;

      const priceAdjustments = sellingPlanInput.getAttribute('data-price-adjustments');
      if (!priceAdjustments) return;

      let adjustments = [];
      try {
        adjustments = JSON.parse(priceAdjustments);
      } catch (e) {
        console.warn('Invalid price adjustment JSON', e);
        return;
      }

      const adjustment = adjustments[0];
      if (!adjustment) return;

      if (adjustment.value_type === 'percentage') {
        discountElement.textContent = ` ${adjustment.value}%`;
      } else if (adjustment.value_type === 'amount') {
        discountElement.textContent = ` ${this.formatMoney(adjustment.value)}`;
      } else {
        discountElement.textContent = ``;
      }
    }

    formatMoney(cents) {
      const moneyFormat = window.theme?.moneyFormat || '${{amount}}';
      return formatMoney(cents, moneyFormat) || `$${(cents / 100).toFixed(2)}`;
    }
  }

  customElements.define('wls-s-product-form-frequency', WLS_S_ProductFormFrequency);
}
